import type { ErrorComponentProps } from '@tanstack/react-router';
import { useT } from '../i18n/index.js';
import { Ico } from './Iconos.js';

/**
 * What a screen that broke while it drew shows instead (`defaultErrorComponent`): what happened, in
 * the screen's language, and the way home. It was the router's own page, in English, with nothing
 * to tap (2026-10-13). Nothing recorded is lost: the books are on the device, and home redraws.
 */
export function PantallaDeError({ error, reset }: ErrorComponentProps) {
  const t = useT();
  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-5 p-6 text-center" data-pantalla-de-error>
      <span className="chip chip-ambar size-16 rounded-2xl">
        <Ico icono="aviso" className="size-8" />
      </span>
      <h1 className="text-xl font-semibold">{t('error.pantallaTitulo')}</h1>
      <p className="text-sm text-slate-400">{t('error.pantallaTexto')}</p>
      <p className="max-w-full break-words text-xs text-slate-500">{error instanceof Error ? error.message : String(error)}</p>
      <button
        type="button"
        className="btn-primario"
        onClick={() => {
          reset();
          window.location.assign('/');
        }}
      >
        <Ico icono="inicio" />
        {t('error.volverAlInicio')}
      </button>
    </div>
  );
}
